import React from 'react';
import { Box, Typography, Button, Paper, useTheme, alpha } from '@mui/material';

const PageHeader = ({ title, subtitle, actions = null }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        background: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: 'blur(12px)',
        borderRadius: 4,
        p: { xs: 2, md: 3 },
        mb: 4,
        boxShadow: theme.shadows[2],
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: 2,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Decorative Elements */}
      <Box sx={{
        position: 'absolute',
        top: -20,
        right: -20,
        width: 120,
        height: 120,
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.secondary.main || theme.palette.primary.main, 0.1)} 100%)`,
        borderRadius: '50%',
        pointerEvents: 'none'
      }} />

      <Box sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 3,
        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main || theme.palette.info.main} 100%)`,
      }} />

      <Box sx={{ flex: 1, minWidth: 0, zIndex: 1 }}>
        <Typography variant="h3" fontWeight="700" sx={{
          mb: 1,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main || theme.palette.info.main} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: '-0.025em',
          lineHeight: 1.2
        }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="subtitle1" color="text.secondary" sx={{ opacity: 0.9 }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {actions && (
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', zIndex: 1 }}>
          {actions}
        </Box>
      )}
    </Paper>
  );
};

export default PageHeader;


